import type { OrbProps } from "./Orb";
import { clsx } from "clsx";
import { AnimatePresence } from "motion/react";
import * as m from "motion/react-m";
import type { OrbMessage, AgentMessageStyle, UserMessageStyle } from "./types";
import { OrbDisc } from "./OrbDisc";
import { VoiceMessageList } from "./VoiceMessageList";
import { TextMessageList } from "./TextMessageList";

export type { OrbMessage };

export function OrbWithMessages({
  messages,
  mode = "voice",
  alignMessages = mode === "voice" ? "bottom" : "top",
  messagesClassName,
  orbSize,
  agentMessageStyle,
  userMessageStyle,
  surface = "eggshell",
  gap = "default",
  hideVoiceMessages = false,
  ringClassName,
  ...orbProps
}: OrbProps & {
  messages: OrbMessage[];
  mode?: "voice" | "text";
  alignMessages?: "top" | "bottom";
  messagesClassName?: string;
  orbSize?: "default" | "small";
  agentMessageStyle?: AgentMessageStyle;
  userMessageStyle?: UserMessageStyle;
  surface?: "eggshell" | "cream";
  gap?: "default" | "compact";
  hideVoiceMessages?: boolean;
  ringClassName?: string;
}) {
  return (
    <div className='tw-relative tw-isolate tw-w-72 tw-max-w-full'>
      <OrbDisc mode={mode} orbSize={orbSize} ringClassName={ringClassName} {...orbProps} />
      <AnimatePresence initial={false} mode='popLayout'>
        {mode === "voice" ? (
          <m.div
            key='voice'
            className={clsx("tw-mx-auto tw-w-64 tw-max-w-full tw-aspect-square tw-relative tw-z-30", messagesClassName)}
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0 } }}
          >
            {hideVoiceMessages ? null : (
              <VoiceMessageList
                messages={messages}
                alignMessages={alignMessages}
                agentMessageStyle={agentMessageStyle}
              />
            )}
          </m.div>
        ) : (
          <m.div
            key='text'
            className={clsx(
              "tw-relative tw-z-10 tw-w-72 tw-max-w-full tw-max-h-64 tw-aspect-square",
              messagesClassName,
            )}
            initial={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 0 } }}
          >
            <TextMessageList
              messages={messages}
              alignMessages={alignMessages}
              agentMessageStyle={agentMessageStyle}
              userMessageStyle={userMessageStyle}
              surface={surface}
              gap={gap}
            />
          </m.div>
        )}
      </AnimatePresence>
    </div>
  );
}
